export interface FormFieldOption {
  value: string;
  selected?: boolean;
}

export interface FormDefinitionField {
  name: string;
  type: 'checkbox' | 'radio' | 'radio-group' | 'select' | 'checkbox-group' | string;
  checked?: boolean;
  value?: string;
  multiple?: boolean;
  placeholder?: string;
  values?: FormFieldOption[];
}

export interface ResponseField {
  name: string;
  value: string;
}

export function applyResponseDataToFormDefinition(
  responseData: { fields: ResponseField[] },
  formDefinition: FormDefinitionField[]
): FormDefinitionField[] {
  if (!Array.isArray(responseData.fields)) {
    return formDefinition.map((f) => ({ ...f }));
  }

  const responseMap = new Map(
    responseData.fields.map((f) => [f.name.replace('[]', ''), f])
  );

  return formDefinition.map((def) => {
    const responseField = responseMap.get(def.name);
    if (!responseField) return { ...def };

    const responseValues = responseField.value.split(',');

    switch (def.type) {
      case 'checkbox':
      case 'radio':
        return responseField.value ? { ...def, checked: true } : { ...def };

      case 'radio-group':
      case 'select':
      case 'checkbox-group': {
        if (!def.values) return { ...def };

        // radio-group without multiple should only select the first matching option
        const selectOnlyFirst = def.type === 'radio-group' && !def.multiple;
        let matched = false;

        const newValues = def.values.map((option) => {
          if (selectOnlyFirst && matched) return { ...option, selected: undefined };
          const isMatch =
            responseValues.includes(option.value) ||
            responseValues.includes(' ' + option.value);
          if (isMatch) {
            matched = true;
            return { ...option, selected: true };
          }
          return { ...option, selected: undefined };
        });

        return {
          ...def,
          values: newValues,
          ...('placeholder' in def && matched ? { placeholder: '' } : {}),
        };
      }

      default:
        return { ...def, value: responseField.value };
    }
  });
}
